export const selectTheme = (state) => state.theme;
export const selectIsDarkMode = (state) => state.theme.isDarkMode;
